/* MACC ROASTERS — theme.js */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function dispatchCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.getElementById('MobileNav');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-menu]')) {
      mobileNav && mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-close-menu]') || (mobileNav && e.target === mobileNav.querySelector('.mobile-nav__overlay'))) {
      mobileNav && mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('[data-close-cart]') || (drawer && e.target.classList.contains('cart-drawer__overlay'))) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      mobileNav && mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  function refreshDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html || !drawer) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        if (fresh) {
          var wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = fresh.innerHTML;
          if (wasOpen || openAfter) openDrawer();
        }
      });
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
  }

  /* Add to cart (any form with data-product-form) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var original = button ? button.textContent : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = '…'; }

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart);
        dispatchCartUpdate(cart);
        return refreshDrawer(true);
      })
      .catch(function (err) {
        alert((err && err.description) || 'Could not add to cart.');
      })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.textContent = original; }
      });
  });

  /* Quantity change / remove inside cart drawer and cart page */
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var wrap = qtyBtn.closest('.qty-input');
      var input = wrap && wrap.querySelector('input');
      if (input) {
        var next = Math.max(parseInt(input.min || '0', 10) || 0, (parseInt(input.value, 10) || 0) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var removeLink = e.target.closest('[data-cart-remove]');
    if (removeLink) {
      e.preventDefault();
      changeLine(removeLink.getAttribute('data-cart-remove'), 0, removeLink.closest('[data-cart-context]'));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-line-key]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-key'), parseInt(input.value, 10) || 0, input.closest('[data-cart-context]'));
  });

  function changeLine(key, quantity, context) {
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart);
        dispatchCartUpdate(cart);
        var isCartPage = context && context.getAttribute('data-cart-context') === 'page';
        if (isCartPage) {
          window.location.reload();
        } else {
          refreshDrawer(false);
        }
      });
  }

  /* ---------- Product page: variant picker ---------- */
  document.querySelectorAll('[data-product-wrapper]').forEach(function (wrapper) {
    var dataEl = wrapper.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = wrapper.querySelector('input[name="id"]');
    var priceEls = wrapper.querySelectorAll('[data-price]');
    var button = wrapper.querySelector('[data-atc-button]');

    function currentOptions() {
      var opts = [];
      wrapper.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function onVariantChange() {
      var opts = currentOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
      if (!variant) {
        if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = button.getAttribute('data-text-unavailable') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      priceEls.forEach(function (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<span class="price--sale"><s class="price__regular">' + formatMoney(variant.compare_at_price) + '</s> <span class="price__sale">' + formatMoney(variant.price) + '</span></span>';
        } else {
          priceEl.textContent = variant.price === 0 ? (priceEl.getAttribute('data-text-free') || 'Free') : formatMoney(variant.price);
        }
      });
      if (button) {
        if (variant.available) {
          button.removeAttribute('aria-disabled');
          button.textContent = button.getAttribute('data-text-add') || 'Add to cart';
        } else {
          button.setAttribute('aria-disabled', 'true');
          button.textContent = button.getAttribute('data-text-soldout') || 'Sold out';
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    wrapper.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) onVariantChange();
    });
  });

  /* ---------- Product gallery thumbs ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery && gallery.querySelector('[data-gallery-main] img');
    if (main) {
      main.src = thumb.getAttribute('data-gallery-thumb');
      main.srcset = '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }
  });

  /* ---------- Sticky mobile add-to-cart ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  if (stickyBar) {
    var mainForm = document.querySelector('[data-product-wrapper] form[data-product-form]');
    var mainAtc = document.querySelector('[data-product-wrapper] [data-atc-button]');
    var stickyBtn = stickyBar.querySelector('[data-sticky-atc-button]');

    if (mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', scrolledPast);
      }).observe(mainAtc);
    }

    if (stickyBtn && mainForm) {
      stickyBtn.addEventListener('click', function () {
        if (mainAtc && mainAtc.getAttribute('aria-disabled') === 'true') return;
        if (mainForm.requestSubmit) { mainForm.requestSubmit(); } else { mainForm.submit(); }
      });
    }
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { observer.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
